// react components
import { apiPost } from "../../networkConfig";
import { useState, useEffect } from "react"; 
import { useNavigate } from "react-router-dom";
import { getString } from "../../lang";
import LangugageSelector from "../../components/LanguageSelector/LanguageSelector";
import loginBgImg from '../../assets/images/login-bg-img.jpg';
import toast from 'react-hot-toast';
import NotificationBar from "../../components/NotificationBar/NotificationBar";

import "./Login.css";
import "../../index.css";

// material ui components
import Button from '@mui/material/Button';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

function Login(){
    let [ toggleEyeIcon, setToggleEyeIcon ] = useState(false);
    let [ togglePasswordType, setTogglePasswordType ] = useState("password");
    let [ username, setUsername ] = useState("");
    let [ password, setPassword ] = useState("");
    let [ isValidLogin, setIsValidLogin ] = useState(true);
    let [ isLoading, setIsLoading ] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // console.log("useEffect called");
    }, [])
    
    // methods
    const togglePassWordVisibility = () => {
        const nextToggle = !toggleEyeIcon;

        if(nextToggle) {
            setTogglePasswordType('text');
        }else{
            setTogglePasswordType('password');
        }

        setToggleEyeIcon( nextToggle );
    }

    const validateLoginCredentials = () => {
        let isValid = true;

        if(username.trim() === "" || password.trim() === ""){
            isValid = false;
            setIsValidLogin(false);
            setIsLoading(false);
        }else{
            setIsValidLogin(true);
            
            setIsLoading(true);
            
            performLogin();
        }

        return isValid;
    }

    const performLogin = async () => {
        try {
            let res = await apiPost("api/admin_dashboard/admin_login", { username: username, password: password });

            setIsLoading(false);

            if(res.data && res.data.status){
                if(res.data?.profile_data){
                    localStorage.setItem("user_info", JSON.stringify(res.data.profile_data));
                }
                
                if(res.data.token_data && res.data.token_data.access_token){
                    window.localStorage.setItem("access_token", res.data.token_data.access_token);
                    toast.success(getString("logged_in_success"));
                    navigate("/app/home", { replace: true });
                }else{
                    toast.error(getString("logged_in_error"));
                }
            }else{
                toast.error(getString("logged_in_error"));
            }

        }catch(err){
            console.log("login err ", err);
            toast.error(getString("logged_in_error"));
            setIsLoading(false);
        }
    }

    // template
    return (
        <div className="Login" style={{
                backgroundImage: `linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url(${loginBgImg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                minHeight: "100vh",
            }}>
            
            {/* notification */}
            <NotificationBar />

            <div className="login-container">
                <div className="login-card p-[30px]">
                    <h4 className="title text-lg">{getString("login_title")}</h4>

                    <div className="sub-title text-[0.9em] my-1">
                        {getString("login_subtitle")}
                    </div>

                    <div className="input-group mt-5">
                        <div>
                            <input type="text" value={ username } placeholder={getString("username_placeholder")} className="input-control text-sm mb-[10px]" onChange={ (e) => setUsername(e.target.value) } />
                        </div>

                        <div className="password-input-group relative">
                            <input type={ togglePasswordType } value={ password } placeholder={getString("password_placeholder")} className="input-control text-sm" onChange={ (e) => setPassword(e.target.value) } />

                           { toggleEyeIcon ? < VisibilityOutlinedIcon onClick={ togglePassWordVisibility }  className="icon-eye" /> : <VisibilityOffOutlinedIcon onClick={ togglePassWordVisibility }  className="icon-eye hidden" /> } 
                            
                        </div>

                        {/* validation error msg */}
                        { !isValidLogin && <div className="error-msg">{ getString( "login_error_invalid_credentials" ) }</div> }
                    </div>

                    <div className="mt-5 flex justify-between items-center">
                        <LangugageSelector />
                        
                        <Button size="small" variant="contained" className="sm-btn btn-filled" onClick={ validateLoginCredentials } loading={isLoading}>{getString('login_button')}</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login;